import { toDate as n } from "./toDate.js";
function a(e) {
  const t = n(e), o = t.getMonth();
  return t.setFullYear(t.getFullYear(), o + 1, 0), t.setHours(23, 59, 59, 999), t;
}
export {
  a as default,
  a as endOfMonth
};
//# sourceMappingURL=endOfMonth.js.map
